<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";

export default {
  name: "HostnameDnsAudit",
  data() {
    return {
      loading: false,
      reCheckLoader: false,
      resolveLoader: false,
      incorrectHostname: [],
    }
  },
  mounted() {
    this.getIncorrectHostname()
  },
  methods: {
    initDataTable(msg) {
      /* eslint-disable */
      $(document).ready(function () {
        $(".audit-hostname").DataTable({
          ordering: true,
          retrieve: true,
          'columnDefs': [{
            'targets': [3],
            'orderable': false,
          }],
          language: {
            search: "_INPUT_",
            searchPlaceholder: "Search",
            emptyTable: msg,
            size: '40'
          }
        });
      });
      /* eslint-enable */
    },
    async recheck(row) {
      this.reCheckLoader = row.id
      try {
        const resp = await this.$http.post('/utilities/check-hostname-audit', {
          grant_type: 'token',
          hbServiceID: row.hbServiceID,
          ip: row.serverIP,
          hostname: row.hostname
        })
        if (resp.data.data && resp.data.data.auditAction.includes('deleted')) {
          this.incorrectHostname = this.incorrectHostname.filter(el => el.id !== row.id)
          swal('Success', 'This hostname has been fixed and removed from the list!', 'success')
        } else {
          swal('Warning', `${resp.data.data.apiResponse.message}`, 'warning')
        }
      } catch (e) {
        console.log(e.toString())
      }
      this.reCheckLoader = null
    },
    async resolve(row) {
      this.resolveLoader = row.id
      const res = await swal({
        title: "Are you sure?",
        text: "Are you sure that you want to resolve this hostname record?",
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      });
      if (res.value) {
        try {
          const resp = await this.$http.post('/utilities/resolve-hostname-audit', {
            grant_type: 'token',
            hbServiceID: row.hbServiceID,
            ip: row.serverIP,
            hostname: row.hostname
          })
          if (resp.data.data && resp.data.data.auditAction.includes('deleted')) {
            this.incorrectHostname = this.incorrectHostname.filter(el => el.id !== row.id)
            swal('Success', 'This hostname has been fixed and removed from the list!', 'success')
          } else {
            swal('Warning', `${resp.data.data.apiResponse.message}`, 'warning')
          }
        } catch (e) {
          console.log(e.toString())
          swal('Error', 'Something went wrong!', 'error')
        }
      }
      this.resolveLoader = null
    },
    async getIncorrectHostname() {
      try {
        this.loading = true
        this.incorrectHostname = []
        if ($.fn.DataTable && $.fn.DataTable.isDataTable('.audit-hostname')) {
          $(".audit-hostname").DataTable().destroy();
        }
        let ref = await db.collection('auditHostname').get()
        if(ref.size) {
          ref.forEach(el => {
            this.incorrectHostname.push({id: el.id, ...el.data()})
          })
        }

      } catch (e) {
        console.log('error while fetching hostname', e.toString())
      } finally {
        this.loading = false;
        this.initDataTable("No record found for audit");
      }
    },
  }
}
</script>

<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              Hostname DNS Audit
            </h4>
            <p>
              This tab scans hostname DNS records and report the invalid ones.
            </p>
          </div>
          <div class="card-body">
            <table class="table table-striped table-bordered audit-hostname">
              <thead>
              <tr>
                <th class="text-center">HB Service ID</th>
                <th class="text-center">Hostname</th>
                <th class="text-center">Server IP</th>
                <th class="text-center">Message</th>
                <th class="text-center">Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(row, index) in incorrectHostname" :key="index">
                <td class="text-center">{{ row.hbServiceID }}</td>
                <td width="25%">{{ row.hostname }}</td>
                <td class="text-center">{{ row.serverIP }}</td>
                <td class="text-center" width="25%">{{ row.apiMessage }}</td>
                <td class="text-center" width="30%">
                  <button title="Resolve" type="button" rel="tooltip" :disabled="resolveLoader" class="btn btn-outline-success  btn-sm mr-4" @click="resolve(row)">
                    <div class="loader small_loader" style="width: 20px;height:20px" v-if="resolveLoader === row.id"></div>
                    <span v-else>
                    <i class="fa fa-check"></i> Resolve
                    </span>
                  </button>
                  <button title="Resolve" type="button" rel="tooltip" :disabled="reCheckLoader" class="btn btn-outline-primary  btn-sm mr-4" @click="recheck(row)">
                    <div class="loader small_loader" style="width: 25px;height:25px" v-if="reCheckLoader === row.id"></div>
                    <span v-else>
                    <i class="fa fa-refresh"></i> Re-check
                    </span>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
